import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { IconRestore } from "@tabler/icons-react";
import { useState } from "react";
import Functions from "../../../../callable/functions";
import Usuario from "../../../../models/usuario";
import { useSnackBar } from "../../../../stores/snackBarStores";
import { FirebaseError } from "firebase/app";

type Props = {
  cliente: Usuario;
  open: boolean;
  onClose: (success: boolean) => void;
};
export default function DesarquivarClienteDialog({
  cliente,
  open,
  onClose,
}: Props) {
  const [desarquivando, setDesarquivando] = useState(false);
  const snackBar = useSnackBar();

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle color="text.primary">
        <Box display="flex" flexDirection="row" alignItems="center">
          <Box mr={1}>
            <IconRestore size={16} />
          </Box>
          <Typography variant="h4">
            Desarquivar {cliente.nome}?
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Você e todos do seu escritório poderão operar esse cliente novamente.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="inherit">
          Cancelar
        </Button>
        <LoadingButton
          color="primary"
          variant="contained"
          loading={desarquivando}
          onClick={() => {
            setDesarquivando(true);
            new Functions()
              .desarquivarCliente({ clienteId: cliente.id })
              .then(() => {
                snackBar({
                  type: "ALERT",
                  payload: {
                    mensagem: `O cliente ${cliente.nome} foi desarquivado.`,
                    severidade: "success",
                  },
                });
              })
              .catch((error: FirebaseError) => {
                snackBar({
                  type: "ALERT",
                  payload: {
                    mensagem: error.message,
                    severidade: "error",
                  },
                });
              })
              .finally(() => {
                setDesarquivando(false);
                onClose(true);
              });
          }}
        >
          Desarquivar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
